import { messenger } from "./EvToast";
import store from '@/store/index'

export default (error) => {
    const res = error.response;
    if(!res || !res.data){
        return Promise.reject(error);
    }
    if (res.status === 401 || res.status === 402) {

        if(store.getters['user/user']){
            messenger.$message({type:'error', message:'잘못된 접근입니다.'});
            store.dispatch('user/logout',{ alert: false })
        } else {
            messenger.$message({type:'error', message: res.data.message || '로그인이 필요합니다.'});
        }

        // 권한 오류시 로그인 리다이렉트. TODO :: 에러 수정 필요
        //
        // let redirect = messenger.$route.fullPath;
        // messenger.$router.push({name: 'Login', query:{ redirect: redirect }});

        return Promise.reject(error);
    }
    if (res.status === 404 ) {
        if(res.data.message){
            messenger.$message({type:'warning', message:res.data.message, showClose:true});
        }
        return Promise.reject(error);
    }

    if (res.status === 403 || res.status === 405) {
        if(!res.data.message){
            messenger.$message({type:'warning',showClose:true,message:'접근할 수 없는 기능입니다.'});
        }
    }
    if(res.status === 406 ){
        if(!res.data.message){
            messenger.$message({type:'warning',showClose:true,message:'문제가 지속적일 경우 고객선테로 연락 주시기 바랍니다.'});
        }
    }
    if(res.data.message){
        messenger.$message({type:'warning', message:res.data.message, showClose:true});
    }
    return Promise.reject(error);
}
